import { Component, OnInit, ViewChild, Output, EventEmitter, } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { IOption } from "ng-select";
import { NgForm } from "@angular/forms";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { HelperService } from "../../services/helper.service";


import { QuestionBankService } from "../../services/question-bank.service";

@Component({
  selector: "app-question-bank",
  templateUrl: "./question-bank-modal.component.html",
  styleUrls: ["./question-bank-modal.component.scss"],
  providers: [QuestionBankService],
})

export class QuestionBankModalComponent implements OnInit {
  @Output() public questionBankReload: EventEmitter<any> = new EventEmitter<any>();
  
  public masterData: any = {};
  formData = {
    code: "",
    description: "",
    comment: "",
    active: 0,
  };

  isEdit: number;
  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();
  // languageSystemID = +this.helperService.getAvailableLang();
  languageSystemID = 1;

  activeStatus = [
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
  ];


  constructor(
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private helperService: HelperService,
    private QuestionBankService: QuestionBankService
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {
    this.generateRandomQBNumber();
  }

  codeGenerated = "";

  generateRandomQBNumber() {
    const randomNumber = Math.floor(Math.random() * 99999) + 1;
    this.formData.code = `QB/${randomNumber.toString().padStart(6, "0")}`;
    this.codeGenerated = this.formData.code;
  }


  addQuestionBank(formData: any) {
    const activeValue = formData.active === undefined ? 0 : formData.active;
    const requestData = {
      code: this.codeGenerated,
      description: formData.description,
      comment: formData.comment,
      active: activeValue,
      company_id: this.companySystemID,
      language_id: this.languageSystemID,
    };

    let that = this;
    that.masterData.companySystemID = that.companySystemID;
    that.QuestionBankService.createQuestionBank()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          //console.log(resp);
          that.masterData = {};
          that.successMsg = "";
          that.successMsg = "Successfully added question bank";
          that.showSuccessHtml();
          that.closeModalAfterCreate();
          this.questionBankReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(error.data.message);
            that.showErrorHtml();
            // this.questionBankReload.emit();
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-modal/question-bank-modal.component.ts